(function() {

	// Timeline Constructor
	function Timeline() {
		var triggers = document.querySelectorAll('.timeline-trigger');
		for (var i = 0; i < triggers.length; i++) {
			triggers[i].addEventListener('click', handleTimelineClick);
		}
	}

	// Handle timeline click event
	function handleTimelineClick(event) {
		var clickedItem = event.currentTarget.parentElement;
		var isOpen = clickedItem.classList.contains('open');
		var timeline = clickedItem.closest('.wp-block-nars-timeline');
		var itemToOpen = null;

		if (!isOpen) {
			itemToOpen = clickedItem;
			openItem(itemToOpen);
		}

		closeOtherTimelineItems(timeline, itemToOpen);
	}

	// Open timeline item
	function openItem(accItem) {
		var body = accItem.querySelector('.timeline-body');

		accItem.classList.add('opening');
		body.removeAttribute('hidden');
		body.style.maxHeight = body.scrollHeight + 'px';

		setTimeout(function() {
			body.style.maxHeight = null;
			accItem.querySelector('.timeline-trigger').setAttribute('aria-expanded', 'true');
			accItem.classList.remove('opening');
			accItem.classList.add('open');
		}, 300);
	}

	// Close timeline item
	function closeItem(accItem) {
		var body = accItem.querySelector('.timeline-body');

		body.style.maxHeight = body.scrollHeight + 'px';

		setTimeout(function() {
			accItem.classList.remove('open');
			body.style.maxHeight = null;
		}, 50);

		setTimeout(function() {
			accItem.querySelector('.timeline-trigger').setAttribute('aria-expanded', 'false');
			body.setAttribute('hidden', 'true');
		}, 300);
	}

	// Close all other timelines except the opened one
	function closeOtherTimelineItems(timeline, itemToOpen) {
		var items = timeline.querySelectorAll('.wp-block-nars-timeline-item');
		for (var i = 0; i < items.length; i++) {
			var accItem = items[i];
			if (accItem !== itemToOpen && accItem.classList.contains('open')) {
				closeItem(accItem);
			}
		}
	}

	// Initialize Timeline
	document.addEventListener('DOMContentLoaded', Timeline);

})();